/**
 * Abstract
 *
 * A summary of the resource.
 *
 * http://purl.org/dc/terms/abstract
 */
var abstract = 'http://purl.org/dc/terms/abstract';
/**
 * Access Rights
 *
 * Information about who access the resource or an indication of its security status.
 *
 * http://purl.org/dc/terms/accessRights
 */
var accessRights = 'http://purl.org/dc/terms/accessRights';
/**
 * Accrual Method
 *
 * The method by which items are added to a collection.
 *
 * http://purl.org/dc/terms/accrualMethod
 */
var accrualMethod = 'http://purl.org/dc/terms/accrualMethod';
/**
 * Accrual Periodicity
 *
 * The frequency with which items are added to a collection.
 *
 * http://purl.org/dc/terms/accrualPeriodicity
 */
var accrualPeriodicity = 'http://purl.org/dc/terms/accrualPeriodicity';
/**
 * Accrual Policy
 *
 * The policy governing the addition of items to a collection.
 *
 * http://purl.org/dc/terms/accrualPolicy
 */
var accrualPolicy = 'http://purl.org/dc/terms/accrualPolicy';
/**
 * Alternative Title
 *
 * An alternative name for the resource.
 *
 * http://purl.org/dc/terms/alternative
 */
var alternative = 'http://purl.org/dc/terms/alternative';
/**
 * Audience
 *
 * A class of agents for whom the resource is intended or useful.
 *
 * http://purl.org/dc/terms/audience
 */
var audience = 'http://purl.org/dc/terms/audience';
/**
 * Date Available
 *
 * Date that the resource became or will become available.
 *
 * http://purl.org/dc/terms/available
 */
var available = 'http://purl.org/dc/terms/available';
/**
 * Bibliographic Citation
 *
 * A bibliographic reference for the resource.
 *
 * http://purl.org/dc/terms/bibliographicCitation
 */
var bibliographicCitation = 'http://purl.org/dc/terms/bibliographicCitation';
/**
 * Conforms To
 *
 * An established standard to which the described resource conforms.
 *
 * http://purl.org/dc/terms/conformsTo
 */
var conformsTo = 'http://purl.org/dc/terms/conformsTo';
/**
 * Contributor
 *
 * An entity responsible for making contributions to the resource.
 *
 * http://purl.org/dc/terms/contributor
 */
var contributor = 'http://purl.org/dc/terms/contributor';
/**
 * Coverage
 *
 * The spatial or temporal topic of the resource, spatial applicability of the resource, or jurisdiction under which the resource is relevant.
 *
 * http://purl.org/dc/terms/coverage
 */
var coverage = 'http://purl.org/dc/terms/coverage';
/**
 * Date Created
 *
 * Date of creation of the resource.
 *
 * http://purl.org/dc/terms/created
 */
var created = 'http://purl.org/dc/terms/created';
/**
 * Creator
 *
 * An entity responsible for making the resource.
 *
 * http://purl.org/dc/terms/creator
 */
var creator = 'http://purl.org/dc/terms/creator';
/**
 * Date
 *
 * A point or period of time associated with an event in the lifecycle of the resource.
 *
 * http://purl.org/dc/terms/date
 */
var date = 'http://purl.org/dc/terms/date';
/**
 * Date Accepted
 *
 * Date of acceptance of the resource.
 *
 * http://purl.org/dc/terms/dateAccepted
 */
var dateAccepted = 'http://purl.org/dc/terms/dateAccepted';
/**
 * Date Copyrighted
 *
 * Date of copyright of the resource.
 *
 * http://purl.org/dc/terms/dateCopyrighted
 */
var dateCopyrighted = 'http://purl.org/dc/terms/dateCopyrighted';
/**
 * Date Submitted
 *
 * Date of submission of the resource.
 *
 * http://purl.org/dc/terms/dateSubmitted
 */
var dateSubmitted = 'http://purl.org/dc/terms/dateSubmitted';
/**
 * Description
 *
 * An account of the resource.
 *
 * http://purl.org/dc/terms/description
 */
var description = 'http://purl.org/dc/terms/description';
/**
 * Audience Education Level
 *
 * A class of agents, defined in terms of progression through an educational or training context, for which the described resource is intended.
 *
 * http://purl.org/dc/terms/educationLevel
 */
var educationLevel = 'http://purl.org/dc/terms/educationLevel';
/**
 * Extent
 *
 * The size or duration of the resource.
 *
 * http://purl.org/dc/terms/extent
 */
var extent = 'http://purl.org/dc/terms/extent';
/**
 * Format
 *
 * The file format, physical medium, or dimensions of the resource.
 *
 * http://purl.org/dc/terms/format
 */
var format = 'http://purl.org/dc/terms/format';
/**
 * Has Format
 *
 * A related resource that is substantially the same as the pre-existing described resource, but in another format.
 *
 * http://purl.org/dc/terms/hasFormat
 */
var hasFormat = 'http://purl.org/dc/terms/hasFormat';
/**
 * Has Part
 *
 * A related resource that is included either physically or logically in the described resource.
 *
 * http://purl.org/dc/terms/hasPart
 */
var hasPart = 'http://purl.org/dc/terms/hasPart';
/**
 * Has Version
 *
 * A related resource that is a version, edition, or adaptation of the described resource.
 *
 * http://purl.org/dc/terms/hasVersion
 */
var hasVersion = 'http://purl.org/dc/terms/hasVersion';
/**
 * Identifier
 *
 * An unambiguous reference to the resource within a given context.
 *
 * http://purl.org/dc/terms/identifier
 */
var identifier = 'http://purl.org/dc/terms/identifier';
/**
 * Instructional Method
 *
 * A process, used to engender knowledge, attitudes and skills, that the described resource is designed to support.
 *
 * http://purl.org/dc/terms/instructionalMethod
 */
var instructionalMethod = 'http://purl.org/dc/terms/instructionalMethod';
/**
 * Is Format Of
 *
 * A pre-existing related resource that is substantially the same as the described resource, but in another format.
 *
 * http://purl.org/dc/terms/isFormatOf
 */
var isFormatOf = 'http://purl.org/dc/terms/isFormatOf';
/**
 * Is Part Of
 *
 * A related resource in which the described resource is physically or logically included.
 *
 * http://purl.org/dc/terms/isPartOf
 */
var isPartOf = 'http://purl.org/dc/terms/isPartOf';
/**
 * Is Referenced By
 *
 * A related resource that references, cites, or otherwise points to the described resource.
 *
 * http://purl.org/dc/terms/isReferencedBy
 */
var isReferencedBy = 'http://purl.org/dc/terms/isReferencedBy';
/**
 * Is Replaced By
 *
 * A related resource that supplants, displaces, or supersedes the described resource.
 *
 * http://purl.org/dc/terms/isReplacedBy
 */
var isReplacedBy = 'http://purl.org/dc/terms/isReplacedBy';
/**
 * Is Required By
 *
 * A related resource that requires the described resource to support its function, delivery, or coherence.
 *
 * http://purl.org/dc/terms/isRequiredBy
 */
var isRequiredBy = 'http://purl.org/dc/terms/isRequiredBy';
/**
 * Is Version Of
 *
 * A related resource of which the described resource is a version, edition, or adaptation.
 *
 * http://purl.org/dc/terms/isVersionOf
 */
var isVersionOf = 'http://purl.org/dc/terms/isVersionOf';
/**
 * Date Issued
 *
 * Date of formal issuance of the resource.
 *
 * http://purl.org/dc/terms/issued
 */
var issued = 'http://purl.org/dc/terms/issued';
/**
 * Language
 *
 * A language of the resource.
 *
 * http://purl.org/dc/terms/language
 */
var language = 'http://purl.org/dc/terms/language';
/**
 * License
 *
 * A legal document giving official permission to do something with the resource.
 *
 * http://purl.org/dc/terms/license
 */
var license = 'http://purl.org/dc/terms/license';
/**
 * Mediator
 *
 * An entity that mediates access to the resource.
 *
 * http://purl.org/dc/terms/mediator
 */
var mediator = 'http://purl.org/dc/terms/mediator';
/**
 * Medium
 *
 * The material or physical carrier of the resource.
 *
 * http://purl.org/dc/terms/medium
 */
var medium = 'http://purl.org/dc/terms/medium';
/**
 * Date Modified
 *
 * Date on which the resource was changed.
 *
 * http://purl.org/dc/terms/modified
 */
var modified = 'http://purl.org/dc/terms/modified';
/**
 * Provenance
 *
 * A statement of any changes in ownership and custody of the resource since its creation that are significant for its authenticity, integrity, and interpretation.
 *
 * http://purl.org/dc/terms/provenance
 */
var provenance = 'http://purl.org/dc/terms/provenance';
/**
 * Publisher
 *
 * An entity responsible for making the resource available.
 *
 * http://purl.org/dc/terms/publisher
 */
var publisher = 'http://purl.org/dc/terms/publisher';
/**
 * References
 *
 * A related resource that is referenced, cited, or otherwise pointed to by the described resource.
 *
 * http://purl.org/dc/terms/references
 */
var references = 'http://purl.org/dc/terms/references';
/**
 * Relation
 *
 * A related resource.
 *
 * http://purl.org/dc/terms/relation
 */
var relation = 'http://purl.org/dc/terms/relation';
/**
 * Replaces
 *
 * A related resource that is supplanted, displaced, or superseded by the described resource.
 *
 * http://purl.org/dc/terms/replaces
 */
var replaces = 'http://purl.org/dc/terms/replaces';
/**
 * Requires
 *
 * A related resource that is required by the described resource to support its function, delivery, or coherence.
 *
 * http://purl.org/dc/terms/requires
 */
var requires = 'http://purl.org/dc/terms/requires';
/**
 * Rights
 *
 * Information about rights held in and over the resource.
 *
 * http://purl.org/dc/terms/rights
 */
var rights = 'http://purl.org/dc/terms/rights';
/**
 * Rights Holder
 *
 * A person or organization owning or managing rights over the resource.
 *
 * http://purl.org/dc/terms/rightsHolder
 */
var rightsHolder = 'http://purl.org/dc/terms/rightsHolder';
/**
 * Source
 *
 * A related resource from which the described resource is derived.
 *
 * http://purl.org/dc/terms/source
 */
var source = 'http://purl.org/dc/terms/source';
/**
 * Spatial Coverage
 *
 * Spatial characteristics of the resource.
 *
 * http://purl.org/dc/terms/spatial
 */
var spatial = 'http://purl.org/dc/terms/spatial';
/**
 * Subject
 *
 * A topic of the resource.
 *
 * http://purl.org/dc/terms/subject
 */
var subject = 'http://purl.org/dc/terms/subject';
/**
 * Table Of Contents
 *
 * A list of subunits of the resource.
 *
 * http://purl.org/dc/terms/tableOfContents
 */
var tableOfContents = 'http://purl.org/dc/terms/tableOfContents';
/**
 * Temporal Coverage
 *
 * Temporal characteristics of the resource.
 *
 * http://purl.org/dc/terms/temporal
 */
var temporal = 'http://purl.org/dc/terms/temporal';
/**
 * Title
 *
 * A name given to the resource.
 *
 * http://purl.org/dc/terms/title
 */
var title = 'http://purl.org/dc/terms/title';
/**
 * Type
 *
 * The nature or genre of the resource.
 *
 * http://purl.org/dc/terms/type
 */
var type = 'http://purl.org/dc/terms/type';
/**
 * Date Valid
 *
 * Date (often a range) of validity of a resource.
 *
 * http://purl.org/dc/terms/valid
 */
var valid = 'http://purl.org/dc/terms/valid';
/**
 * Agent
 *
 * A resource that acts or has the power to act.
 *
 * http://purl.org/dc/terms/Agent
 */
var Agent = 'http://purl.org/dc/terms/Agent';
/**
 * Agent Class
 *
 * A group of agents.
 *
 * http://purl.org/dc/terms/AgentClass
 */
var AgentClass = 'http://purl.org/dc/terms/AgentClass';
/**
 * Bibliographic Resource
 *
 * A book, article, or other documentary resource.
 *
 * http://purl.org/dc/terms/BibliographicResource
 */
var BibliographicResource = 'http://purl.org/dc/terms/BibliographicResource';
/**
 * File Format
 *
 * A digital resource format.
 *
 * http://purl.org/dc/terms/FileFormat
 */
var FileFormat = 'http://purl.org/dc/terms/FileFormat';
/**
 * Frequency
 *
 * A rate at which something recurs.
 *
 * http://purl.org/dc/terms/Frequency
 */
var Frequency = 'http://purl.org/dc/terms/Frequency';
/**
 * Jurisdiction
 *
 * The extent or range of judicial, law enforcement, or other authority.
 *
 * http://purl.org/dc/terms/Jurisdiction
 */
var Jurisdiction = 'http://purl.org/dc/terms/Jurisdiction';
/**
 * License Document
 *
 * A legal document giving official permission to do something with a resource.
 *
 * http://purl.org/dc/terms/LicenseDocument
 */
var LicenseDocument = 'http://purl.org/dc/terms/LicenseDocument';
/**
 * Linguistic System
 *
 * A system of signs, symbols, sounds, gestures, or rules used in communication.
 *
 * http://purl.org/dc/terms/LinguisticSystem
 */
var LinguisticSystem = 'http://purl.org/dc/terms/LinguisticSystem';
/**
 * Location
 *
 * A spatial region or named place.
 *
 * http://purl.org/dc/terms/Location
 */
var Location = 'http://purl.org/dc/terms/Location';
/**
 * Location, Period, or Jurisdiction
 *
 * A location, period of time, or jurisdiction.
 *
 * http://purl.org/dc/terms/LocationPeriodOrJurisdiction
 */
var LocationPeriodOrJurisdiction = 'http://purl.org/dc/terms/LocationPeriodOrJurisdiction';
/**
 * Media Type
 *
 * A file format or physical medium.
 *
 * http://purl.org/dc/terms/MediaType
 */
var MediaType = 'http://purl.org/dc/terms/MediaType';
/**
 * Media Type or Extent
 *
 * A media type or extent.
 *
 * http://purl.org/dc/terms/MediaTypeOrExtent
 */
var MediaTypeOrExtent = 'http://purl.org/dc/terms/MediaTypeOrExtent';
/**
 * Method of Accrual
 *
 * A method by which resources are added to a collection.
 *
 * http://purl.org/dc/terms/MethodOfAccrual
 */
var MethodOfAccrual = 'http://purl.org/dc/terms/MethodOfAccrual';
/**
 * Method of Instruction
 *
 * A process that is used to engender knowledge, attitudes, and skills.
 *
 * http://purl.org/dc/terms/MethodOfInstruction
 */
var MethodOfInstruction = 'http://purl.org/dc/terms/MethodOfInstruction';
/**
 * Period of Time
 *
 * An interval of time that is named or defined by its start and end dates.
 *
 * http://purl.org/dc/terms/PeriodOfTime
 */
var PeriodOfTime = 'http://purl.org/dc/terms/PeriodOfTime';
/**
 * Physical Medium
 *
 * A physical material or carrier.
 *
 * http://purl.org/dc/terms/PhysicalMedium
 */
var PhysicalMedium = 'http://purl.org/dc/terms/PhysicalMedium';
/**
 * Physical Resource
 *
 * A material thing.
 *
 * http://purl.org/dc/terms/PhysicalResource
 */
var PhysicalResource = 'http://purl.org/dc/terms/PhysicalResource';
/**
 * Policy
 *
 * A plan or course of action by an authority, intended to influence and determine decisions, actions, and other matters.
 *
 * http://purl.org/dc/terms/Policy
 */
var Policy = 'http://purl.org/dc/terms/Policy';
/**
 * Provenance Statement
 *
 * Any changes in ownership and custody of a resource since its creation that are significant for its authenticity, integrity, and interpretation.
 *
 * http://purl.org/dc/terms/ProvenanceStatement
 */
var ProvenanceStatement = 'http://purl.org/dc/terms/ProvenanceStatement';
/**
 * Rights Statement
 *
 * A statement about the intellectual property rights (IPR) held in or over a resource, a legal document giving official permission to do something with a resource, or a statement about access rights.
 *
 * http://purl.org/dc/terms/RightsStatement
 */
var RightsStatement = 'http://purl.org/dc/terms/RightsStatement';
/**
 * Size or Duration
 *
 * A dimension or extent, or a time taken to play or execute.
 *
 * http://purl.org/dc/terms/SizeOrDuration
 */
var SizeOrDuration = 'http://purl.org/dc/terms/SizeOrDuration';
/**
 * Standard
 *
 * A reference point against which other things can be evaluated or compared.
 *
 * http://purl.org/dc/terms/Standard
 */
var Standard = 'http://purl.org/dc/terms/Standard';
/**
 * DCMI Box
 *
 * The set of regions in space defined by their geographic coordinates according to the DCMI Box Encoding Scheme.
 *
 * http://purl.org/dc/terms/Box
 */
var Box = 'http://purl.org/dc/terms/Box';
/**
 * ISO 3166
 *
 * The set of codes listed in ISO 3166-1 for the representation of names of countries.
 *
 * http://purl.org/dc/terms/ISO3166
 */
var ISO3166 = 'http://purl.org/dc/terms/ISO3166';
/**
 * DCMI Period
 *
 * The set of time intervals defined by their limits according to the DCMI Period Encoding Scheme.
 *
 * http://purl.org/dc/terms/Period
 */
var Period = 'http://purl.org/dc/terms/Period';
/**
 * DCMI Point
 *
 * The set of points in space defined by their geographic coordinates according to the DCMI Point Encoding Scheme.
 *
 * http://purl.org/dc/terms/Point
 */
var Point = 'http://purl.org/dc/terms/Point';
/**
 * RFC 1766
 *
 * The set of tags, constructed according to RFC 1766, for the identification of languages.
 *
 * http://purl.org/dc/terms/RFC1766
 */
var RFC1766 = 'http://purl.org/dc/terms/RFC1766';
/**
 * RFC 3066
 *
 * The set of tags constructed according to RFC 3066 for the identification of languages.
 *
 * http://purl.org/dc/terms/RFC3066
 */
var RFC3066 = 'http://purl.org/dc/terms/RFC3066';
/**
 * RFC 4646
 *
 * The set of tags constructed according to RFC 4646 for the identification of languages.
 *
 * http://purl.org/dc/terms/RFC4646
 */
var RFC4646 = 'http://purl.org/dc/terms/RFC4646';
/**
 * RFC 5646
 *
 * The set of tags constructed according to RFC 5646 for the identification of languages.
 *
 * http://purl.org/dc/terms/RFC5646
 */
var RFC5646 = 'http://purl.org/dc/terms/RFC5646';
/**
 * URI
 *
 * The set of identifiers constructed according to the generic syntax for Uniform Resource Identifiers as specified by the Internet Engineering Task Force.
 *
 * http://purl.org/dc/terms/URI
 */
var URI = 'http://purl.org/dc/terms/URI';
/**
 * W3C-DTF
 *
 * The set of dates and times constructed according to the W3C Date and Time Formats Specification.
 *
 * http://purl.org/dc/terms/W3CDTF
 */
var W3CDTF = 'http://purl.org/dc/terms/W3CDTF';

var dctImport = /*#__PURE__*/Object.freeze({
	abstract: abstract,
	accessRights: accessRights,
	accrualMethod: accrualMethod,
	accrualPeriodicity: accrualPeriodicity,
	accrualPolicy: accrualPolicy,
	alternative: alternative,
	audience: audience,
	available: available,
	bibliographicCitation: bibliographicCitation,
	conformsTo: conformsTo,
	contributor: contributor,
	coverage: coverage,
	created: created,
	creator: creator,
	date: date,
	dateAccepted: dateAccepted,
	dateCopyrighted: dateCopyrighted,
	dateSubmitted: dateSubmitted,
	description: description,
	educationLevel: educationLevel,
	extent: extent,
	format: format,
	hasFormat: hasFormat,
	hasPart: hasPart,
	hasVersion: hasVersion,
	identifier: identifier,
	instructionalMethod: instructionalMethod,
	isFormatOf: isFormatOf,
	isPartOf: isPartOf,
	isReferencedBy: isReferencedBy,
	isReplacedBy: isReplacedBy,
	isRequiredBy: isRequiredBy,
	isVersionOf: isVersionOf,
	issued: issued,
	language: language,
	license: license,
	mediator: mediator,
	medium: medium,
	modified: modified,
	provenance: provenance,
	publisher: publisher,
	references: references,
	relation: relation,
	replaces: replaces,
	requires: requires,
	rights: rights,
	rightsHolder: rightsHolder,
	source: source,
	spatial: spatial,
	subject: subject,
	tableOfContents: tableOfContents,
	temporal: temporal,
	title: title,
	type: type,
	valid: valid,
	Agent: Agent,
	AgentClass: AgentClass,
	BibliographicResource: BibliographicResource,
	FileFormat: FileFormat,
	Frequency: Frequency,
	Jurisdiction: Jurisdiction,
	LicenseDocument: LicenseDocument,
	LinguisticSystem: LinguisticSystem,
	Location: Location,
	LocationPeriodOrJurisdiction: LocationPeriodOrJurisdiction,
	MediaType: MediaType,
	MediaTypeOrExtent: MediaTypeOrExtent,
	MethodOfAccrual: MethodOfAccrual,
	MethodOfInstruction: MethodOfInstruction,
	PeriodOfTime: PeriodOfTime,
	PhysicalMedium: PhysicalMedium,
	PhysicalResource: PhysicalResource,
	Policy: Policy,
	ProvenanceStatement: ProvenanceStatement,
	RightsStatement: RightsStatement,
	SizeOrDuration: SizeOrDuration,
	Standard: Standard,
	Box: Box,
	ISO3166: ISO3166,
	Period: Period,
	Point: Point,
	RFC1766: RFC1766,
	RFC3066: RFC3066,
	RFC4646: RFC4646,
	RFC5646: RFC5646,
	URI: URI,
	W3CDTF: W3CDTF
});

export { type as $, instructionalMethod as A, isFormatOf as B, isPartOf as C, isReferencedBy as D, isReplacedBy as E, isRequiredBy as F, isVersionOf as G, issued as H, language as I, license as J, mediator as K, medium as L, modified as M, provenance as N, publisher as O, references as P, relation as Q, replaces as R, requires as S, rights as T, rightsHolder as U, source as V, spatial as W, subject as X, tableOfContents as Y, temporal as Z, title as _, abstract as a, valid as a0, Agent as a1, AgentClass as a2, BibliographicResource as a3, FileFormat as a4, Frequency as a5, Jurisdiction as a6, LicenseDocument as a7, LinguisticSystem as a8, Location as a9, LocationPeriodOrJurisdiction as aa, MediaType as ab, MediaTypeOrExtent as ac, MethodOfAccrual as ad, MethodOfInstruction as ae, PeriodOfTime as af, PhysicalMedium as ag, PhysicalResource as ah, Policy as ai, ProvenanceStatement as aj, RightsStatement as ak, SizeOrDuration as al, Standard as am, Box as an, ISO3166 as ao, Period as ap, Point as aq, RFC1766 as ar, RFC3066 as as, RFC4646 as at, RFC5646 as au, URI as av, W3CDTF as aw, dctImport as ax, accessRights as b, accrualMethod as c, accrualPeriodicity as d, accrualPolicy as e, alternative as f, audience as g, available as h, bibliographicCitation as i, conformsTo as j, contributor as k, coverage as l, created as m, creator as n, date as o, dateAccepted as p, dateCopyrighted as q, dateSubmitted as r, description as s, educationLevel as t, extent as u, format as v, hasFormat as w, hasPart as x, hasVersion as y, identifier as z };
